export default __webpack_public_path__ + "static/media/andean5.fd86f2c9.jpg";